/* The Urban Pot — single-pot listing builder.
   ONE file serves all seven style listings; the style is a section setting.

   Reuses the same 66 pot renders as the Urban Stem listings, so there is nothing new to
   upload. The renders all include the wall/rail arm on the pot's left side. Every view here
   clips that arm away at the pot's own left wall, because:
     · straight on against a wall, the arm is behind the pot and genuinely invisible
     · on the desktop version the arm is unclipped from the pot altogether
   The mount disc is drawn in code and tinted to the pot, so all six colors exist with no
   extra photography. */
function upInit(root){
  if (!root || root.dataset.upReady) return;
  root.dataset.upReady = '1';

  var ASSET_BASE = root.dataset.assetBase || '';
  var STYLE = (root.dataset.style || 'archie').toLowerCase();

  /* [potLeft, potRight, potTop, potBottom, renderHeight] for every one of the 66 renders,
     measured by scanning each PNG's alpha channel: on each row the pot is the rightmost run
     of pixels, and any row whose run reaches left of x=795 is the arm merged with the pot and
     tells us nothing. potLeft is the critical figure — the pot's true leftmost point, rim
     flare included. The arm never reaches past x=793, so cutting at potLeft removes all of it
     and none of the pot. */
  var BODY = {
    'large-archie':{white:[801,1193,59,564,621],black:[805,1187,59,547,603],latte:[807,1201,58,570,627],terracotta:[807,1179,59,547,605],green:[809,1207,59,556,613],blue:[804,1176,58,546,604]},
    'large-echo':{white:[811,1180,58,562,620],black:[810,1169,60,554,612],latte:[811,1165,60,544,602],terracotta:[811,1168,60,544,602],green:[804,1161,59,555,613],blue:[810,1164,59,539,597]},
    'large-lattice':{white:[803,1200,59,519,576],black:[809,1207,58,534,591],latte:[812,1189,58,504,561],terracotta:[806,1190,59,506,563],green:[804,1195,59,518,576],blue:[808,1202,60,531,586]},
    'large-linus':{white:[810,1201,59,545,602],black:[803,1194,59,566,623],latte:[812,1187,59,527,584],terracotta:[814,1212,59,545,602],green:[816,1189,58,531,587],blue:[795,1182,60,571,628]},
    'large-poppy':{white:[807,1186,60,550,607],black:[809,1178,59,547,604],latte:[809,1189,59,556,613],terracotta:[803,1198,59,568,625],green:[796,1169,59,521,578],blue:[806,1182,60,549,606]},
    'large-smooth':{white:[797,1246,58,553,608],black:[812,1234,59,547,604],latte:[811,1235,58,538,593],terracotta:[799,1259,58,574,630],green:[802,1235,60,542,598],blue:[803,1236,59,541,597]},
    'large-spiral':{white:[816,1186,59,509,565],black:[813,1179,59,521,578],latte:[822,1181,59,512,568],terracotta:[813,1199,59,528,584],green:[815,1171,59,497,554],blue:[814,1178,59,515,571]},
    'small-archie':{white:[808,1079,60,396,455],black:[811,1079,60,397,457],latte:[809,1086,60,396,455],terracotta:[812,1079,60,386,446],green:[806,1075,59,391,451],blue:[810,1073,59,395,454]},
    'small-linus':{white:[810,1083,60,394,453],black:[812,1079,60,388,448],latte:[812,1083,60,391,450],terracotta:[807,1087,60,393,452],green:[813,1082,59,389,449],blue:[810,1076,59,387,446]},
    'small-poppy':{white:[811,1078,59,402,462],black:[812,1069,60,389,449],latte:[809,1067,59,387,447],terracotta:[811,1076,59,385,445],green:[814,1069,59,383,443],blue:[806,1076,60,403,462]},
    'small-smooth':{white:[807,1119,60,405,463],black:[806,1118,60,400,458],latte:[805,1116,59,403,460],terracotta:[813,1113,60,398,456],green:[795,1111,60,405,464],blue:[805,1117,59,402,459]}
  };

  /* ---------- the desktop silhouette ----------
     On the desktop version there is no arm at all, so the render has to be cut along the pot's
     own outline rather than at a straight edge: the pot's left edge drifts rightwards as it
     descends and curves in sharply at the base, so any straight cut either leaves a sliver of
     arm behind or bites into the pot.

     POT  — per colour: [renderHeight, potTop, potBottom, potRight, potLeft]. Each colour was
            photographed in its own frame, so these differ.
     PROF — per shape: the left edge at 14 heights, as a fraction of the pot's width. One
            profile serves all six colours because it is the same model on the same camera. */
  var POT = {
    'large-archie':{white:[621,59,620,1193,804],black:[603,59,602,1187,806],latte:[627,58,626,1201,804],terracotta:[605,59,604,1179,808],green:[613,59,612,1207,806],blue:[604,57,603,1176,804]},
    'large-echo':{white:[620,58,619,1180,811],black:[612,59,611,1169,810],latte:[602,59,601,1165,811],terracotta:[602,59,601,1168,811],green:[613,59,612,1161,808],blue:[597,59,596,1164,811]},
    'large-lattice':{white:[576,58,575,1201,806],black:[591,58,590,1207,808],latte:[561,58,560,1192,812],terracotta:[563,59,562,1192,805],green:[576,59,575,1196,804],blue:[586,58,585,1203,807]},
    'large-linus':{white:[602,58,601,1201,810],black:[623,59,622,1194,812],latte:[584,58,583,1187,815],terracotta:[602,59,601,1212,814],green:[587,57,586,1189,816],blue:[628,59,627,1199,812]},
    'large-poppy':{white:[607,59,606,1186,808],black:[604,59,603,1178,809],latte:[613,59,612,1189,808],terracotta:[625,59,624,1198,802],green:[578,59,577,1169,807],blue:[606,59,605,1182,808]},
    'large-smooth':{white:[608,58,607,1246,809],black:[604,59,603,1234,814],latte:[593,58,592,1235,807],terracotta:[630,58,629,1259,808],green:[598,60,597,1235,808],blue:[597,59,596,1236,803]},
    'large-spiral':{white:[565,59,564,1191,815],black:[578,57,577,1188,814],latte:[568,58,567,1188,823],terracotta:[584,58,583,1205,815],green:[554,59,553,1178,815],blue:[571,58,570,1185,814]},
    'small-archie':{white:[455,59,454,1079,809],black:[457,60,456,1079,810],latte:[455,60,454,1086,809],terracotta:[446,59,445,1079,811],green:[451,59,450,1075,807],blue:[454,59,453,1073,810]},
    'small-linus':{white:[453,60,452,1083,810],black:[448,59,447,1079,812],latte:[450,59,449,1083,812],terracotta:[452,60,451,1087,808],green:[449,59,448,1082,813],blue:[446,59,445,1076,810]},
    'small-poppy':{white:[462,59,461,1078,810],black:[449,60,448,1069,812],latte:[447,59,446,1067,809],terracotta:[445,59,444,1077,812],green:[443,59,442,1069,813],blue:[462,60,461,1076,809]},
    'small-smooth':{white:[463,60,462,1119,813],black:[458,60,457,1118,807],latte:[460,59,459,1116,804],terracotta:[456,59,455,1113,811],green:[464,60,463,1111,806],blue:[459,59,458,1117,804]}
  };
  var PROF = {
    'large-archie':[0.3853,0,0.0027,0.0051,0.0053,0.008,0.0106,0.0133,0.0159,0.0173,0.0266,0.1235,0.4509,0.4509],
    'large-echo':[0.3818,0.0042,0.0014,0.0028,0.0028,0.0028,0.0041,0.0055,0.0041,0.0028,0.0014,0.1091,0.4439,0.4439],
    'large-lattice':[0.3402,0.0052,0,0,0.0013,0.0025,0.0013,0.0013,0.0104,0.0025,0.0287,0.1622,0.553,0.553],
    'large-linus':[0.3687,0,0,0,0,0,0.0013,0.0013,0,0.0025,0.019,0.1217,0.4465,0.4465],
    'large-poppy':[0.353,0.0117,0.0132,0,0.0026,0.0027,0.0054,0.008,0.0107,0.012,0.0161,0.1255,0.4437,0.4437],
    'large-smooth':[0.3579,0,0.007,0.0079,0.0114,0.0141,0.0142,0.0154,0.0165,0.0482,0.0641,0.1674,0.4638,0.4638],
    'large-spiral':[0.3763,0.0245,0.0204,0.0177,0.0122,0.0095,0.0054,0,0.0136,0.0677,0.1222,0.2038,0.4736,0.4736],
    'small-archie':[0.3001,0,0.0018,0.0018,0.0018,0.0037,0.0037,0.0037,0.0037,0.0055,0.0585,0.3228,0.438,0.438],
    'small-linus':[0.3365,0,0.0019,0.0019,0.0019,0,0,0,0,0.0037,0.0657,0.3469,0.4462,0.4462],
    'small-poppy':[0.3396,0,0,0.0039,0.0039,0.0039,0.0076,0.0058,0.0096,0.0096,0.0362,0.3456,0.4532,0.4532],
    'small-smooth':[0.2344,0.0032,0.0064,0.008,0.0111,0.0081,0.0065,0.0049,0.0033,0.0527,0.119,0.3194,0.4672,0.4672]
  };

  var COLORS = ['white','black','latte','terracotta','green','blue'];
  var HEX = {white:'#DFD8D1',black:'#35373A',latte:'#C9AC90',terracotta:'#D9663C',green:'#6E6B4C',blue:'#4E5474'};
  var NAMES = {white:'White',black:'Black',latte:'Latte',terracotta:'Terracotta',green:'Green',blue:'Blue',
    archie:'Archie',echo:'Echo',lattice:'Lattice',linus:'Linus',poppy:'Poppy',smooth:'Smooth',spiral:'Spiral',
    large:'Large',small:'Small',wall:'Wall mounted',desk:'Desktop'};
  /* only these four were moulded in a small size, and they are also the only ones with a
     lift-out inner pot — Echo, Lattice and Spiral are large-only and one piece */
  var HAS_SMALL = {archie:1,linus:1,poppy:1,smooth:1};

  var sizes = HAS_SMALL[STYLE] ? ['large','small'] : ['large'];
  var size = sizes[0], color = 'white', mount = 'wall', view = -1;
  var layer = 0, cache = {};

  /* ---------- stage geometry ----------
     Stage units are render units 1:1, so a small pot really is drawn smaller than a large one
     and the size choice is visible rather than merely stated. */
  var SW = 810, SH = 972;
  var BASELINE = SH - 168;

  var stage   = root.querySelector('[data-stage]');
  var base    = root.querySelector('[data-base]');
  var disc    = root.querySelector('[data-disc]');
  var wallsh  = root.querySelector('[data-wallshadow]');
  var surface = root.querySelector('[data-surface]');
  var contact = root.querySelector('[data-contact]');
  var photo   = root.querySelector('[data-photo]');
  var badge   = root.querySelector('[data-badge]');
  var pots    = root.querySelectorAll('[data-pot]');
  var thumbs  = root.querySelectorAll('[data-view]');

  var VARIANTS = [];
  var vnode = root.querySelector('[data-variants]');
  if (vnode){ try { VARIANTS = JSON.parse(vnode.textContent) || []; } catch(e){ VARIANTS = []; } }

  function q(sel){ return root.querySelector(sel); }
  function bodyOf(){ return (BODY[size+'-'+STYLE] || BODY['large-archie'])[color]; }
  function src(){ return ASSET_BASE + 'urban-stem-' + size + '-' + STYLE + '-' + color + '.png'; }
  function preload(u){ if (cache[u]) return cache[u]; var im = new Image(); im.src = u; cache[u] = im; return im; }

  /* ---------- variant matching ----------
     The store owner names their own options, so rather than assume a layout we look at what
     the variants actually say. If nothing matches we fall back to the first variant and the
     section's own price settings, so the page still works before variants are set up. */
  function anyOpt(re){
    return VARIANTS.some(function(v){ return (v.opts||[]).some(function(o){ return re.test(o); }); });
  }
  var USES_SIZE  = anyOpt(/^\s*(large|small)\b/i);
  var USES_MOUNT = anyOpt(/wall|desk/i);
  /* What each of our colors may be called in the store's own variant names —
     e.g. this store's variants say "Orange" where the listing says Terracotta. */
  var COLOR_ALIAS = {white:'white|cream|ivory',black:'black|charcoal',latte:'latte|beige|tan',
    terracotta:'terracotta|terra cotta|orange|rust|clay',green:'green|olive|sage',blue:'blue|navy'};
  function colorRe(c){ return new RegExp('\\b(?:' + (COLOR_ALIAS[c] || c) + ')\\b', 'i'); }
  var USES_COLOR = COLORS.some(function(c){ return anyOpt(colorRe(c)); });

  function matchVariant(){
    if (!VARIANTS.length) return null;
    var want = [];
    if (USES_SIZE)  want.push(new RegExp('^\\s*' + size, 'i'));
    if (USES_MOUNT) want.push(mount === 'wall' ? /wall/i : /desk/i);
    if (USES_COLOR) want.push(colorRe(color));
    var hit = VARIANTS.filter(function(v){
      return want.every(function(re){
        return (v.opts||[]).some(function(o){ return re.test(o); });
      });
    });
    var avail = hit.filter(function(v){ return v.available; });
    return avail[0] || hit[0] || VARIANTS[0];
  }

  /* ---------- drawing ---------- */
  /* The desktop cut. Walks the pot's own left edge through the 14 profile heights, so the arm
     and its collar come off completely and nothing of the pot goes with them. Wall mode keeps
     its simpler rectangular cut — the arm reads correctly there and you liked it as it is. */
  function deskClip(b){
    var key = size + '-' + STYLE;
    var p = (POT[key] || POT['large-archie'])[color];
    var pr = PROF[key] || PROF['large-archie'];
    var H = p[0], T = p[1], Bm = p[2], R = p[3], L = p[4], W = R - L, n = pr.length;
    var bottom = Math.min(b[3] + 1, Bm);    var lo = 1, hi = n - 4;                       // the samples that describe the pot's body
    /* Below the last body sample the cut carries on at the same rate the pot's edge was already
       drifting right, rather than dropping straight down. Going vertical there left the very tip
       of the arm showing on the wider shapes; and since the pot's own outline turns right faster
       than linear as it meets the base, extrapolating the body's slope stays clear of it. */
    var slope = (pr[hi] - pr[hi - 2]) / 2, rows = (Bm - T) / (n - 1);
    var endIdx = (bottom - T) / rows;
    var endPr = Math.max(pr[hi], pr[hi] + slope * (endIdx - hi));
    var xTop = L + pr[lo] * W + 2, xBot = L + endPr * W + 4;
    /* Only the body samples are used. The arm sits on the body, and there the pot's left edge
       drifts right as it descends — that drift is what a straight cut cannot follow. Above and
       below the body the outline curves hard inward at the rim and base, and no arm reaches
       that far, so the cut simply runs straight down from the first body sample and straight on
       from the last: stepping back to the pot's leftmost edge instead left a visible notch. */
    var pts = [[xTop, T], [R + 1, T], [R + 1, bottom], [xBot, bottom]];
    for (var i = hi; i >= lo; i--){
      var y = T + (Bm - T) * i / (n - 1);
      if (y >= bottom) continue;
      pts.push([L + pr[i] * W + 2, y]);
    }
    return 'polygon(' + pts.map(function(q){
      return (q[0] / 1500 * 100).toFixed(3) + '% ' + (q[1] / H * 100).toFixed(3) + '%';
    }).join(',') + ')';
  }

  function draw(){
    if (!base) return;
    base.style.width  = SW + 'px';
    base.style.height = SH + 'px';

    var b = bodyOf();
    var potW = b[1] - b[0], potH = b[3] - b[2];
    var px = Math.round((SW - potW) / 2);
    var py = mount === 'wall' ? Math.round(SH * 0.44 - potH / 2) : (BASELINE - potH);

    /* the mount disc: about 60% of the pot's width, sitting behind the pot and a little left
       of its centre, so only a crescent of it shows — exactly what a straight-on photo gives */
    if (disc){
      var d = Math.round(potW * 0.60);
      var cx = px + potW * 0.12, cy = py + potH * 0.40;
      disc.style.display = mount === 'wall' ? 'block' : 'none';
      disc.style.width  = d + 'px';
      disc.style.height = d + 'px';
      disc.style.left   = Math.round(cx - d/2) + 'px';
      disc.style.top    = Math.round(cy - d/2) + 'px';
      disc.style.backgroundColor = HEX[color];
      disc.style.backgroundImage =
        'radial-gradient(70% 64% at 34% 27%,rgba(255,255,255,.30),rgba(255,255,255,0) 60%),'
        + 'radial-gradient(112% 112% at 50% 50%,rgba(0,0,0,0) 76%,rgba(0,0,0,.13) 93%,rgba(0,0,0,.05)),'
        + 'linear-gradient(122deg,rgba(255,255,255,.14),rgba(0,0,0,0) 44%,rgba(0,0,0,.19))';
      disc.style.boxShadow = '10px 12px 16px rgba(74,58,40,.20),inset 0 0 0 1px rgba(0,0,0,.08)';
    }

    // wall mode: the pot casts its shadow onto the wall, down and to the right
    if (wallsh){
      wallsh.style.display = mount === 'wall' ? 'block' : 'none';
      wallsh.style.left   = Math.round(px + potW * 0.10) + 'px';
      wallsh.style.top    = Math.round(py + potH * 0.12) + 'px';
      wallsh.style.width  = Math.round(potW * 0.92) + 'px';
      wallsh.style.height = Math.round(potH * 0.88) + 'px';
    }

    // desktop mode: a surface to stand on, plus the contact shadow that sells it
    if (surface){
      surface.style.display = mount === 'desk' ? 'block' : 'none';
      surface.style.top     = BASELINE + 'px';
    }
    if (contact){
      contact.style.display = mount === 'desk' ? 'block' : 'none';
      contact.style.left    = Math.round(px - potW * 0.09) + 'px';
      contact.style.top     = Math.round(BASELINE - potH * 0.055) + 'px';
      contact.style.width   = Math.round(potW * 1.18) + 'px';
      contact.style.height  = Math.round(potH * 0.16) + 'px';
    }

    for (var i = 0; i < pots.length; i++){
      var el = pots[i];
      el.style.width = '1500px';
      el.style.left  = (px - b[0]) + 'px';
      el.style.top   = (py - b[2]) + 'px';
      /* Clip to the pot's measured box on all four sides. The left cut is the one that removes
         the mount arm; the other three matter because every render carries a very faint
         low-alpha halo well outside the pot, which otherwise shows up as a hard vertical seam
         running the height of the stage. */
      if (mount === 'desk'){
        el.style.clipPath = el.style.webkitClipPath = deskClip(b);
      } else {
        el.style.clipPath = el.style.webkitClipPath = 'inset('
          + (b[2] / b[4] * 100).toFixed(3) + '% '
          + ((1500 - (b[1] + 1)) / 1500 * 100).toFixed(3) + '% '
          + ((b[4] - (b[3] + 1)) / b[4] * 100).toFixed(3) + '% '
          + ((b[0] + 1) / 1500 * 100).toFixed(3) + '%)';
      }
      el.style.filter = mount === 'wall'
        ? 'drop-shadow(8px 10px 10px rgba(74,58,40,.16))'
        : 'drop-shadow(5px 6px 7px rgba(74,58,40,.14))';
    }
  }

  function rescale(){
    if (!base || !stage) return;
    var w = stage.clientWidth, h = stage.clientHeight;
    if (!w || !h) return;
    /* Fit the whole scene to the stage box, not just its width — on phones the stage is a
       shorter strip, so the scene shrinks and centres instead of overflowing it. */
    var k = Math.min(w / SW, h / SH);
    base.style.transform = 'translate(' + ((w - SW * k) / 2).toFixed(2) + 'px,'
      + ((h - SH * k) / 2).toFixed(2) + 'px) scale(' + k + ')';
  }

  function swap(instant){
    var u = src();
    for (var s = 0; s < pots.length; s++) if (!pots[s].getAttribute('src')) pots[s].src = u;
    var from = pots[layer], to = pots[layer ? 0 : 1];
    draw();
    if (instant || !to){
      if (from){ from.src = u; from.style.opacity = '1'; }
      if (to) to.style.opacity = '0';
      return;
    }
    var im = preload(u), done = false;
    function reveal(){
      if (done) return;
      done = true;
      to.style.opacity = '1';
      from.style.opacity = '0';
      layer = layer ? 0 : 1;
    }
    to.src = u;
    if (im.complete && im.naturalWidth) reveal();
    else { im.onload = reveal; im.onerror = reveal; setTimeout(reveal, 420); }
  }

  function warm(){
    for (var i = 0; i < COLORS.length; i++)
      preload(ASSET_BASE + 'urban-stem-' + size + '-' + STYLE + '-' + COLORS[i] + '.png');
    for (var s = 0; s < sizes.length; s++)
      preload(ASSET_BASE + 'urban-stem-' + sizes[s] + '-' + STYLE + '-' + color + '.png');
  }

  /* Crop each colour swatch's little pot thumbnail onto the pot itself. */
  function chipArt(){
    Array.prototype.forEach.call(root.querySelectorAll('.up-chip-img'), function(img){
      var btn = img.parentNode, sz = btn.dataset.chipsize || 'large', c = btn.dataset.color || color;
      var b = (BODY[sz + '-' + STYLE] || {})[c];
      if (!b) { img.style.display = 'none'; return; }
      var x0 = b[0] - 8, x1 = b[1] + 8, y0 = b[2] - 6, y1 = b[3] + 6;
      var tw = btn.clientWidth || 52, th = btn.clientHeight || 52, pad = 5;
      var k = Math.min((tw - pad*2) / (x1 - x0), (th - pad*2) / (y1 - y0));
      img.style.width  = (1500 * k).toFixed(2) + 'px';
      img.style.height = (b[4] * k).toFixed(2) + 'px';
      img.style.left   = ((tw - (x1-x0)*k)/2 - x0*k).toFixed(2) + 'px';
      img.style.top    = ((th - (y1-y0)*k)/2 - y0*k).toFixed(2) + 'px';
      img.style.clipPath = img.style.webkitClipPath = 'inset('
        + (b[2] / b[4] * 100).toFixed(3) + '% '
        + ((1500 - (b[1] + 1)) / 1500 * 100).toFixed(3) + '% '
        + ((b[4] - (b[3] + 1)) / b[4] * 100).toFixed(3) + '% '
        + ((b[0] + 1) / 1500 * 100).toFixed(3) + '%)';
    });
  }

  function paint(){
    Array.prototype.forEach.call(root.querySelectorAll('[data-color]'), function(b){
      b.classList.toggle('is-on', b.dataset.color === color);
    });
    // scoped to the segmented control: the colour chips are buttons too and must not be
    // caught by the size loop, or every swatch ends up ringed at once
    Array.prototype.forEach.call(root.querySelectorAll('.up-seg [data-size]'), function(b){
      b.classList.toggle('is-on', b.dataset.size === size);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-mount]'), function(b){
      b.classList.toggle('is-on', b.dataset.mount === mount);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-stylepick]'), function(b){
      b.classList.toggle('is-on', b.dataset.stylepick === STYLE);
    });

    var sc = q('[data-sum="color"]'); if (sc) sc.textContent = NAMES[color];
    var ss = q('[data-sum="size"]');  if (ss) ss.textContent = NAMES[size];
    var sm = q('[data-sum="mount"]'); if (sm) sm.textContent = NAMES[mount];
    var st = q('[data-sum="style"]'); if (st) st.textContent = NAMES[STYLE];

    var v = matchVariant();
    var idInput = q('[data-prop="id"]');
    if (idInput && v) idInput.value = v.id;

    var priceEl = q('[data-price]');
    if (priceEl){
      var txt = v && v.priceText;
      if (!txt) txt = size === 'small' ? (root.dataset.priceSmall || '') : (root.dataset.priceLarge || '');
      priceEl.textContent = txt || '';
    }
    var cta = q('[data-cta]');
    if (cta){
      var ok = !v || v.available;
      cta.disabled = !ok;
      cta.textContent = ok ? (root.dataset.ctaLabel || 'Add to Cart') : 'Sold out';
    }

    /* Cart line-item properties: only what the chosen variant doesn't already say. A disabled
       input never submits, so nothing shows twice in the cart. Color is never a variant, so it
       always rides along. */
    /* Suppress a property only when the variant actually being added carries that choice —
       if the match fell back to some other variant, the property still submits so the order
       always records what the buyer picked. */
    function vHas(re){ return !!v && (v.opts || []).some(function(o){ return re.test(o); }); }
    var ci = q('[data-prop="color"]'); if (ci){ ci.value = NAMES[color]; ci.disabled = vHas(colorRe(color)); }
    var si = q('[data-prop="size"]');  if (si){ si.value = NAMES[size]; si.disabled = vHas(new RegExp('^\\s*' + size, 'i')); }
    var mi = q('[data-prop="mount"]'); if (mi){ mi.value = NAMES[mount]; mi.disabled = vHas(mount === 'wall' ? /wall/i : /desk/i); }

    // the note changes with the option, since each one has a different thing worth saying
    var mn = q('[data-mountnote]');
    if (mn) mn.textContent = mount === 'wall'
      ? (root.dataset.noteWall || '')
      : (root.dataset.noteDesk || '');
  }

  function setView(n){
    view = n;
    if (n < 0){
      if (photo) photo.style.opacity = '0';
      if (badge) badge.style.opacity = '1';
    } else {
      var t = q('[data-view="' + n + '"]');
      if (t && t.dataset.src && photo) photo.src = t.dataset.src;
      if (photo) photo.style.opacity = '1';
      if (badge) badge.style.opacity = '0';
    }
    Array.prototype.forEach.call(thumbs, function(b){
      b.classList.toggle('is-on', +b.dataset.view === n);
    });
  }

  root.addEventListener('click', function(e){
    var t;
    if ((t = e.target.closest('[data-color]'))){
      color = t.dataset.color; setView(-1); swap(false); chipArt(); paint(); warm(); return;
    }
    if ((t = e.target.closest('[data-size]'))){
      size = t.dataset.size; setView(-1); swap(false); chipArt(); paint(); warm(); return;
    }
    if ((t = e.target.closest('[data-mount]'))){
      mount = t.dataset.mount; setView(-1); swap(true); paint(); return;
    }
    if ((t = e.target.closest('[data-stylepick]'))){
      STYLE = t.dataset.stylepick;
      sizes = HAS_SMALL[STYLE] ? ['large','small'] : ['large'];
      if (sizes.indexOf(size) < 0) size = 'large';
      // the colour swatches show the large render of whatever style is showing
      Array.prototype.forEach.call(root.querySelectorAll('.up-chip-img'), function(img){
        img.src = ASSET_BASE + 'urban-stem-large-' + STYLE + '-' + img.parentNode.dataset.color + '.png';
      });
      var only = q('[data-sizeonly]');
      if (only) only.style.display = sizes.length > 1 ? 'none' : 'block';
      var row = q('[data-sizerow]');
      if (row) row.style.display = sizes.length > 1 ? '' : 'none';
      setView(-1); swap(true); chipArt(); paint(); warm(); return;
    }
    if ((t = e.target.closest('[data-view]'))){ setView(+t.dataset.view); return; }
  });

  if (stage) stage.addEventListener('pointerenter', warm);

  draw();
  rescale();
  if (window.ResizeObserver && stage) new ResizeObserver(rescale).observe(stage);
  else window.addEventListener('resize', rescale);
  window.addEventListener('load', function(){ rescale(); chipArt(); });

  swap(true);
  chipArt();
  paint();
  setView(-1);
  warm();
}

function upBoot(scope){
  var list = (scope || document).querySelectorAll('.up[data-asset-base]');
  for (var i = 0; i < list.length; i++) upInit(list[i]);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ upBoot(); });
else upBoot();
document.addEventListener('shopify:section:load', function(e){ upBoot(e.target); });
